import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserId } from "../../features/feature1/feature1Slice";
import { useNavigate } from "react-router-dom";
import {
  uploadPrescription,
  resetUpload,
} from "../../features/prescription/prescriptionSlice";
import { selectUploadStatus } from "../../features/prescription/prescriptionSelectors";
import {  toast } from "react-toastify"; // Import Toastify

const UploadPrescription = () => {
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const userId = useSelector((state) => state.feature1.userId);
  const { uploadComplete, loading, error } = useSelector(selectUploadStatus);

  // Fetch userId and reset upload state on component mount/unmount
  useEffect(() => {
    dispatch(getUserId());
    return () => {
      dispatch(resetUpload());
    };
  }, [dispatch]);

  // Navigate after upload completes
  useEffect(() => {
    if (uploadComplete) { 
      toast.success("Prescription uploaded successfully!");  // Success toast message
      navigate("/profile?tab=prescription ");
    }
  }, [uploadComplete, navigate]);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userId) {
      // Show error if user is not logged in
      toast.error("Please login to upload your prescription.");  // Error toast message      return;
    }

    if (!file) {
      toast.warn("Please select a file to upload.");  // Warning toast message      return;
    }

    dispatch(uploadPrescription({ file, userId }));
  };

  return (
    <div className="container clear my-orders py-5">
      <h2 className="manage-profile-heading">Upload Prescription</h2>
      <form onSubmit={handleSubmit} className="row mt-2">
        <div className="col-lg-12 col-sm-12 col-md-12">
          <div className="pop-but h-300 mh-100">
            <div className="ordered-details">
              <label
                className={`order-button ${!userId ? "disabled" : ""}`} // Disable styling if not logged in
                htmlFor="fileInput"
                style={{ cursor: userId ? "pointer" : "not-allowed" }} // Adjust cursor style
              >
                Choose from gallery
              </label>
              <input
                type="file"
                id="fileInput"
                onChange={handleFileChange}
                style={{ display: "none" }}
                disabled={!userId} // Disable the input if the user is not logged in
              />
            </div>
          </div>

          {!userId && ( // Show a message if the user is not logged in
            <p className="text-danger mt-2">Please Login first to upload a prescription.</p>
          )}

          {file && (
            <button
              type="submit"
              className="btn btn-primary mt-3"
              disabled={loading || !userId} // Disable submit if loading or not logged in
            >
              {loading ? "Uploading..." : "Submit"}
            </button>
          )}

          {error && <p className="text-danger mt-2">{error}</p>}
        </div>
      </form>
    </div>
  );
};

export default UploadPrescription;

